import { deleteCookie, findCookie } from 'app/core/cookie';

function safeMunchkinInvoke(fn, ...args) {
    const munchkin = (<any>window).Munchkin;
    if (munchkin && munchkin[fn]) {
        munchkin[fn](...args);
    }
}

function munchkinFunction(...args) {
    safeMunchkinInvoke('munchkinFunction', ...args);
}

function associateLead(properties, hash) {
    munchkinFunction('associateLead', properties, hash);
}

function clickLink(href: string, params: string = null) {
    munchkinFunction('clickLink', { href, params });
}

function visitWebPage(url: string, params: string = null) {
    munchkinFunction('visitWebPage', { url, params });
}

const cookieName = '_mkto_trk';

function getCookie() {
    return findCookie(cookieName);
}

function logout() {
    deleteCookie(cookieName)
    safeMunchkinInvoke('createTrackingCookie', true);
}

export default {
    associateLead,
    clickLink,
    visitWebPage,
    getCookie,
    logout
};